import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

export const HotPageSkeleton = () => {
  return (
    <div className={s.container}>
      <Skeleton className={s.item} />
      <Skeleton className={s.item} />
      <Skeleton className={s.item} />
      <Skeleton className={s.item} />
      <Skeleton className={s.item} />
      <Skeleton className={s.item} />
      <Skeleton className={s.item} />
    </div>
  )
}
